import React, { Component } from 'react';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import countryList from 'react-select-country-list';
import BlockUi from 'react-block-ui';
import CustomSelect from '../Base/Common/CustomSelect';
import { CheckAuthorization } from '../Base/Authorization';
import { getAPI, putAPI } from '../Base/API';
import { handleNotification } from '../Base/Common/Notification';
import { ErrorAlert } from '../Base/ErrorAlert';
import moment from 'moment';

class RegistVoucherOnPmsModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            blockPaymentMethods: false,
            blockPmsUsers: false,
            blockProfile: false,
            blockRooms: false,
            blockSave: false,
            chargeToRoom: false,
            rooms: [],
            register: {
                voucherTypeIds: [],
                hostPaymentCodes: [
                    {
                        hostPaymentCode: null,
                        amount: null
                    }
                ],
                voucherIds: [],
                customerFirstName: null,
                customerLastName: null,
                customerMail: null,
                customerNif: null,
                customerPhone: null,
                customerAddress: null,
                customerCity: null,
                customerPostCode: null,
                customerCountryCode: null,
                hostUserCode: null,
                hostUserCashboxCode: null,
                hostUserPassword: null,
                roomFolio: null
            },
            paymentMethods: [],
            pmsUsers: [],
            lastAttempt: null,
            showLastAttemptDetails: false
        };
        this.form = React.createRef();
        this.getPmsData = this.getPmsData.bind(this);
        this.getProfile = this.getProfile.bind(this);
        this.getLastAttempt = this.getLastAttempt.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handlePaymentCodeSelect = this.handlePaymentCodeSelect.bind(this);
        this.saveRegist = this.saveRegist.bind(this);
    }

    componentDidMount() {
        const { voucher } = this.props;
        const { register } = this.state;

        if (voucher) {
            // a single standalone voucher becomes a one-entry voucherTypeIds list
            register.voucherTypeIds = [{
                voucherTypeId: voucher.voucherType && voucher.voucherType.id,
                quantity: 1,
                voucherSalePrice: voucher.salePrice,
                code: voucher.voucherType && voucher.voucherType.code
            }];
            register.voucherIds = [voucher.id];
            register.hostPaymentCodes[0].amount = voucher.salePrice;

            if (voucher.name) {
                const names = voucher.name.trim().split(' ');
                if (names.length > 1) {
                    register.customerFirstName = names[0];
                    register.customerLastName = names.slice(1).join(' ');
                }
                else {
                    register.customerFirstName = voucher.name;
                }
            }
            register.customerMail = voucher.email;

            this.setState({ register });
        }

        this.getPmsData();
        this.getProfile();
        this.getLastAttempt();
    }

    getProfile() {
        const { voucher } = this.props;

        if (!voucher || !voucher.profileId) {
            return;
        }

        this.setState({ blockProfile: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                this.setState({ error: [{ message: error.message, stack: error.stack, messageType: 'danger' }], blockProfile: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else if (data.response && data.response.length > 0) {
                    const profile = data.response[0];
                    const register = { ...this.state.register };

                    register.customerNif = profile.fiscalNumber;
                    register.customerPhone = profile.phone;
                    register.customerAddress = profile.address;
                    register.customerCity = profile.city;
                    register.customerPostCode = profile.postCode;
                    register.customerCountryCode = profile.countryCode;
                    // the voucher already carries the buyer name/email; only fall back to the profile when they are missing
                    if (!register.customerFirstName) register.customerFirstName = profile.firstName;
                    if (!register.customerLastName) register.customerLastName = profile.lastName;
                    if (!register.customerMail) register.customerMail = profile.email;

                    this.setState({ register });
                }
            }
            this.setState({ blockProfile: false });
        }, `/api/Voucher/Profile/v1/Profile/${voucher.profileId}`);
    }

    // Last PMS registration attempt for this voucher (AC4), shown so the operator sees why it failed.
    getLastAttempt() {
        const { voucher } = this.props;

        if (!voucher || !voucher.id) {
            return;
        }

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                this.setState({ error: [{ message: error.message, stack: error.stack, messageType: 'danger' }] });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                else if (data.response && data.response.length > 0) {
                    this.setState({ lastAttempt: data.response[0] });
                }
            }
        }, `/api/Voucher/Voucher/v1/voucher/${voucher.id}/lastPmsRegisterAttempt`);
    }

    getPmsData() {
        this.setState({ blockPaymentMethods: true, blockPmsUsers: true });

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockPaymentMethods: false });
                return;
            }
            if (data.errors && data.errors.length > 0) {
                handleNotification(data);
            }
            if (data.response && data.response.length > 0) {
                const paymentMethods = [];
                data.response.forEach(el => {
                    if (!paymentMethods.find(pm => pm.value === el.code)) {
                        paymentMethods.push({ value: el.code, label: el.description });
                    }
                })
                this.setState({ paymentMethods: paymentMethods });
            }
            this.setState({ error: errorMessage, blockPaymentMethods: false });
        }, `/api/Voucher/v1/Config/paymentMethods/${this.props.voucher.hotelId}`);

        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockPmsUsers: false });
                return;
            }
            if (data.errors && data.errors.length > 0) {
                handleNotification(data);
            }
            if (data.response && data.response.length > 0) {
                const users = data.response.map((el) => {
                    const cashBoxes = el.cashBoxes && el.cashBoxes.map(cashBox => ({
                        value: cashBox.cashBoxCode,
                        label: cashBox.cashBoxDescription
                    }));

                    return {
                        value: el.userCode,
                        label: `${el.firstName} ${el.lastName}`,
                        cashBoxes: cashBoxes
                    };
                });
                this.setState({ pmsUsers: users });
            }
            this.setState({ error: errorMessage, blockPmsUsers: false });
        }, `/api/Voucher/v1/Config/pmsUsers/${this.props.voucher.hotelId}`);
    }

    // fetches the resident rooms of the voucher's hotel, once while the modal is open
    loadRoomList = () => {
        const { voucher } = this.props;
        const hotelId = voucher && voucher.hotelId;

        if (!hotelId || this.state.rooms.length > 0) {
            return;
        }

        this.setState({ blockRooms: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                this.setState({ blockRooms: false });
                return;
            }
            if (data) {
                // business errors (hotel without PMS connectivity, hotel outside the group, ...)
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ blockRooms: false });
                    return;
                }

                const rooms = (data.response || []).map(el => {
                    const roomNumber = el.roomNumber ?? el.RoomNumber ?? el.room ?? '';
                    const guestName = el.guestName ?? el.GuestName ?? el.guestFullName ?? '';
                    const folio = el.roomFolio ?? el.RoomFolio;

                    return {
                        value: folio,
                        label: guestName ? `${roomNumber} - ${guestName}` : `${roomNumber}`,
                        roomFolio: folio
                    };
                });

                this.setState({ rooms, blockRooms: false });
            }
            else {
                this.setState({ blockRooms: false });
            }
        }, `/api/Voucher/v1/Config/pms/roomList/${hotelId}`);
    }

    // toggles between paying (cashbox + payment method) and charging the amount to a resident room folio
    handlePaymentDestinationChange = (chargeToRoom) => {
        const { register } = this.state;

        if (chargeToRoom) {
            // charging to the room hides payment method/cashbox, so clear them
            register.hostUserCashboxCode = null;
            register.hostPaymentCodes[0].hostPaymentCode = null;
            this.setState({ chargeToRoom: true, register }, () => this.loadRoomList());
        }
        else {
            // keeping 'Pay' means no roomFolio is sent
            register.roomFolio = null;
            this.setState({ chargeToRoom: false, register });
        }
    }

    handleRoomSelect = (combo) => {
        const { register } = this.state;
        register.roomFolio = combo ? combo.value : null;
        this.setState({ register });
    }

    handleChange(evt) {
        if (evt.target) {
            const { name, value } = evt.target;
            const { register } = this.state;
            register[name] = value;
            this.setState({ register });
        }
    }

    handleSelect(combo, evt) {
        if (evt) {
            const { register } = this.state;
            const name = evt.name;
            // a different operator means the previous cashbox may no longer belong to them
            if (name === 'hostUserCode') {
                register.hostUserCashboxCode = null;
            }
            register[name] = combo && combo.value;
            this.setState({ register });
        }
    }

    handlePaymentCodeSelect(combo) {
        if (combo) {
            const { register } = this.state;
            register.hostPaymentCodes[0].hostPaymentCode = combo.value;
            this.setState({ register });
        }
    }

    saveRegist(e) {
        e.preventDefault();

        const { register, chargeToRoom } = this.state;

        if (this.form.current.reportValidity()) {
            // when charging to a room, a valid roomFolio must be selected
            if (chargeToRoom && !(register.roomFolio > 0)) {
                handleNotification({ errors: [{ message: this.props.intl.formatMessage({ id: 'AddVoucher.SelectRoomRequired' }), code: '' }] });
                return;
            }

            this.setState({ blockSave: true });

            // only send roomFolio when charging to a room
            const payload = { ...register };
            if (!chargeToRoom) {
                delete payload.roomFolio;
            }

            const request = { request: payload };

            putAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, blockSave: false });
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState({ error: errorMessage, blockSave: false });
                        return;
                    }
                    handleNotification(data, <FormattedMessage id="RegistSaleOnPmsModal.SucessfulMessage" />, <FormattedMessage id="generic.success" />);
                    this.setState({ error: errorMessage, blockSave: false }, () => {
                        if (this.props.onRegistered) this.props.onRegistered();
                        this.props.toggle();
                    });
                    return;
                }
                this.setState({ error: errorMessage, blockSave: false });
            }, `/api/Voucher/Voucher/v1/onlineSale/registerSaleOnPms`, request);
        }
    }

    // The last attempt message is the raw PMS response; extract the human message and turn the
    // escaped line breaks into real ones so the expanded detail is readable.
    formatLastAttemptMessage = (msg) => {
        if (!msg) {
            return '';
        }
        let text = msg;
        try {
            const parsed = JSON.parse(msg);
            text = (parsed.PmsResult && parsed.PmsResult.Message) || parsed.Message || JSON.stringify(parsed, null, 2);
        } catch (e) {
            // not JSON — keep the raw text
        }
        return text.replace(/\\r\\n/g, '\n').replace(/\r\n/g, '\n');
    }

    render() {
        const { isOpen, toggle } = this.props;
        const { blockPaymentMethods, blockPmsUsers, blockProfile, blockRooms, blockSave, chargeToRoom, rooms, register, pmsUsers, paymentMethods, lastAttempt, showLastAttemptDetails } = this.state;
        const countries = countryList().getData();
        const selectedUser = register.hostUserCode ? pmsUsers.find(el => el.value === register.hostUserCode) : null;
        const cashBoxes = (selectedUser && selectedUser.cashBoxes) || [];

        return (
            <Modal isOpen={isOpen} toggle={toggle} size="xl">
                <ModalHeader toggle={toggle}>
                    <FormattedMessage id="OnlineSalesDetail.RegistOnPms" />
                </ModalHeader>
                <ModalBody>
                    <ErrorAlert error={this.state.error} />
                    <BlockUi tag="div" blocking={blockPaymentMethods || blockPmsUsers || blockProfile || blockRooms || blockSave}>
                        <form ref={this.form}>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <small className="text-muted">
                                    <i className="fa-solid fa-triangle-exclamation text-warning mr-1" />
                                    <FormattedMessage id="RegistVoucherOnPmsModal.ConfirmOnPmsWarning" />
                                </small>
                                {lastAttempt && lastAttempt.date ?
                                    <small className="text-muted text-nowrap ml-3">
                                        <FormattedMessage id="RegistVoucherOnPmsModal.LastAttempt" />: {moment(lastAttempt.date).format('YYYY-MM-DD HH:mm')}
                                        {lastAttempt.message ?
                                            <span className="pointer ml-3 text-primary" onClick={() => this.setState({ showLastAttemptDetails: !showLastAttemptDetails })}>
                                                <FormattedMessage id={showLastAttemptDetails ? "RegistVoucherOnPmsModal.ShowLess" : "RegistVoucherOnPmsModal.ShowMore"} />
                                            </span>
                                            : ''}
                                    </small>
                                    : ''}
                            </div>
                            {showLastAttemptDetails && lastAttempt && lastAttempt.message ?
                                <pre className="mt-2 mb-3 p-2 bg-light border rounded pre-scrollable">{this.formatLastAttemptMessage(lastAttempt.message)}</pre>
                                : ''}
                            <Row className="mt-4">
                                <Col>
                                    <h4>
                                        <FormattedMessage id="RegistSaleOnPmsModal.Vouchers" />
                                    </h4>
                                </Col>
                                <Col className="text-right">
                                    <Button className="btn-host btn-sm" onClick={this.saveRegist} disabled={blockSave}>
                                        <i className="fa-solid fa-floppy-disk" />
                                    </Button>
                                </Col>
                            </Row>
                            <hr className="mb-2 mt-0" />
                            <Row className="mb-2">
                                <Col>
                                    <FormattedMessage id="RegistSaleOnPmsModal.Quantity" />
                                </Col>
                                <Col>
                                    <FormattedMessage id="RegistSaleOnPmsModal.Code" />
                                </Col>
                                <Col>
                                    <FormattedMessage id="RegistSaleOnPmsModal.Total" />
                                </Col>
                            </Row>
                            {
                                register.voucherTypeIds.map((voucherType, key) =>
                                    <Row key={key} className="mb-2">
                                        <Col>
                                            {voucherType.quantity}
                                        </Col>
                                        <Col>
                                            {voucherType.code}
                                        </Col>
                                        <Col>
                                            {voucherType.voucherSalePrice}
                                        </Col>
                                    </Row>
                                )
                            }
                            <Row className="mt-4">
                                <Col>
                                    <h4>
                                        <FormattedMessage id="RegistSaleOnPmsModal.CustomerData" />
                                    </h4>
                                </Col>
                            </Row>
                            <hr className="mb-2 mt-0" />
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="RegistSaleOnPmsModal.CustomerFirstName" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="RegistSaleOnPmsModal.CustomerFirstName">
                                        {
                                            placeholder => <Input type="text" required value={register.customerFirstName !== null ? register.customerFirstName : ''} name="customerFirstName" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="RegistSaleOnPmsModal.CustomerLastName" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="RegistSaleOnPmsModal.CustomerLastName">
                                        {
                                            placeholder => <Input type="text" required value={register.customerLastName !== null ? register.customerLastName : ''} name="customerLastName" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="RegistSaleOnPmsModal.CustomerMail" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="RegistSaleOnPmsModal.CustomerMail">
                                        {
                                            placeholder => <Input type="email" required value={register.customerMail !== null ? register.customerMail : ''} name="customerMail" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="RegistSaleOnPmsModal.CustomerNif" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="RegistSaleOnPmsModal.CustomerNif">
                                        {
                                            placeholder => <Input type="text" required value={register.customerNif !== null ? register.customerNif : ''} name="customerNif" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="AddVoucher.Phone" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="AddVoucher.Phone">
                                        {
                                            placeholder => <Input type="text" value={register.customerPhone !== null ? register.customerPhone : ''} name="customerPhone" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="AddVoucher.CustomerCountryCode" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <CustomSelect
                                        options={countries}
                                        value={register.customerCountryCode ? countries.find(el => el.value === register.customerCountryCode) : null}
                                        name="customerCountryCode"
                                        onChange={this.handleSelect}
                                        placeholder={<FormattedMessage id="AddVoucher.CustomerCountryCode" />}
                                        isClearable
                                        isSearchable
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="AddVoucher.CustomerPostCode" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="AddVoucher.CustomerPostCode">
                                        {
                                            placeholder => <Input type="text" value={register.customerPostCode !== null ? register.customerPostCode : ''} name="customerPostCode" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="AddVoucher.CustomerCity" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="AddVoucher.CustomerCity">
                                        {
                                            placeholder => <Input type="text" value={register.customerCity !== null ? register.customerCity : ''} name="customerCity" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="AddVoucher.Address" />
                                    </Label>
                                </Col>
                                <Col className="col-10">
                                    <FormattedMessage id="AddVoucher.Address">
                                        {
                                            placeholder => <Input type="text" value={register.customerAddress !== null ? register.customerAddress : ''} name="customerAddress" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col>
                                    <h4>
                                        <FormattedMessage id="RegistSaleOnPmsModal.OperatorData" />
                                    </h4>
                                </Col>
                            </Row>
                            <hr className="mb-2 mt-0" />
                            {CheckAuthorization("admin:view") ?
                                <Row className="mb-2 align-items-center">
                                    <Col className="col-2">
                                        <Label className="mb-0">
                                            <FormattedMessage id="AddVoucher.PaymentDestination" />
                                        </Label>
                                    </Col>
                                    <Col className="col-4">
                                        <FormGroup check inline className="mb-0">
                                            <Label check>
                                                <Input
                                                    type="radio"
                                                    name="paymentDestination"
                                                    checked={!chargeToRoom}
                                                    onChange={() => this.handlePaymentDestinationChange(false)}
                                                />
                                                <FormattedMessage id="AddVoucher.Pay" />
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline className="mb-0">
                                            <Label check>
                                                <Input
                                                    type="radio"
                                                    name="paymentDestination"
                                                    checked={chargeToRoom}
                                                    onChange={() => this.handlePaymentDestinationChange(true)}
                                                />
                                                <FormattedMessage id="AddVoucher.ChargeToRoom" />
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    {chargeToRoom ?
                                        <>
                                            <Col className="col-2">
                                                <Label className="mb-0">
                                                    <FormattedMessage id="AddVoucher.Room" />
                                                </Label>
                                            </Col>
                                            <Col className="col-4">
                                                <CustomSelect
                                                    options={rooms}
                                                    value={rooms.find(r => r.value === register.roomFolio) || ''}
                                                    onChange={this.handleRoomSelect}
                                                    placeholder={<FormattedMessage id="AddVoucher.SelectRoom" />}
                                                    isLoading={blockRooms}
                                                    required
                                                />
                                            </Col>
                                        </>
                                    : ''}
                                </Row>
                            : ''}
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="RegistSaleOnPmsModal.HostUserCode" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <CustomSelect
                                        options={pmsUsers}
                                        value={pmsUsers.find(el => el.value === register.hostUserCode) || null}
                                        name="hostUserCode"
                                        onChange={this.handleSelect}
                                        placeholder={<FormattedMessage id="RegistSaleOnPmsModal.HostUserCode" />}
                                        isLoading={blockPmsUsers}
                                        required
                                    />
                                </Col>
                                <Col className="col-2">
                                    <Label>
                                        <FormattedMessage id="RegistSaleOnPmsModal.HostUserPassword" />
                                    </Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="RegistSaleOnPmsModal.HostUserPassword">
                                        {
                                            placeholder => <Input type="password" required value={register.hostUserPassword !== null ? register.hostUserPassword : ''} name="hostUserPassword" onChange={this.handleChange} placeholder={placeholder} />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                            {chargeToRoom ? '' :
                                <Row className="mb-2">
                                    <Col className="col-2">
                                        <Label>
                                            <FormattedMessage id="RegistSaleOnPmsModal.HostPaymentCode" />
                                        </Label>
                                    </Col>
                                    <Col className="col-4">
                                        <CustomSelect
                                            options={paymentMethods}
                                            value={paymentMethods.find(el => el.value === register.hostPaymentCodes[0].hostPaymentCode) || null}
                                            name="hostPaymentCode"
                                            onChange={this.handlePaymentCodeSelect}
                                            placeholder={<FormattedMessage id="RegistSaleOnPmsModal.HostPaymentCode" />}
                                            isLoading={blockPaymentMethods}
                                            required
                                        />
                                    </Col>
                                    <Col className="col-2">
                                        <Label>
                                            <FormattedMessage id="RegistSaleOnPmsModal.HostUserCashboxCode" />
                                        </Label>
                                    </Col>
                                    <Col className="col-4">
                                        <CustomSelect
                                            options={cashBoxes}
                                            name="hostUserCashboxCode"
                                            value={register.hostUserCashboxCode ? cashBoxes.find(el => el.value === register.hostUserCashboxCode) || null : null}
                                            onChange={this.handleSelect}
                                            placeholder={<FormattedMessage id="RegistSaleOnPmsModal.HostUserCashboxCode" />}
                                            isDisabled={!register.hostUserCode}
                                            required
                                        />
                                    </Col>
                                </Row>
                            }
                        </form>
                    </BlockUi>
                </ModalBody>
            </Modal>
        );
    }
}

export default injectIntl(RegistVoucherOnPmsModal);
